<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="重新生成"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-image
        :src="shareTestUrl"
        :preview-src-list="[shareTestUrl]"
      />
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';

export default {
  name: 'CourseShareTest',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    shareTestUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '查看分享码',
      cancelText: '取消',
    };
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  .el-image{
    width: 400px;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
